import PropTypes from 'prop-types';
import React from 'react';

import Browser from '@wetransfer/concorde-browser';
import Cookie from '@wetransfer/concorde-cookie';

import FeatureFlagsHelper from '@app/helper/featureflags';
import UserModel from '@app/model/user';

import I18n from '@module/i18n';

import TipNotification from '@component/info/tip';

const Tip = ({ route }) => {
  let title = null;
  let subtitle = null;

  const mapping = {
    '/transfers': {
      adminTitleKey: 'page.transfers.teams_tip.title',
      adminSubtitleKey: 'page.transfers.teams_tip.subtitle',
      memberTitleKey: 'page.transfers.team_member_tip.title',
      memberSubtitleKey: 'page.transfers.team_member_tip.subtitle',
    },
    '/contacts': {
      adminTitleKey: 'page.contact.teams_tip.title',
      adminSubtitleKey: 'page.contact.teams_tip.subtitle',
      memberTitleKey: 'page.contact.team_member_tip.title',
      memberSubtitleKey: 'page.contact.team_member_tip.subtitle',
    },
    '/profile': {
      adminTitleKey: 'page.profile.teams_tip.title',
      adminSubtitleKey: 'page.profile.teams_tip.subtitle',
      memberTitleKey: 'page.profile.team_member_tip.title',
      memberSubtitleKey: 'page.profile.team_member_tip.subtitle',
    },
    '/account': {
      memberTitleKey: 'page.userinfo.team_member_tip.title',
      memberSubtitleKey: 'page.userinfo.team_member_tip.subtitle',
    },
  };

  /*
   * Don't show if the mapping is missing
   * Don't show on mobile
   * Don't show if already shown
   * Don't show tooltip for v3 users
   * Don't show tooltip for users without teams
   */
  if (!mapping[route.path]) {
    return null;
  }
  if (Browser.isMobile) {
    return null;
  }
  if (Cookie.get('wt_team_onboarded') === 'true') {
    return null;
  }
  if (!FeatureFlagsHelper.hasTeams) {
    return null;
  }

  if (UserModel.isAdmin) {
    title = mapping[route.path].adminTitleKey
      ? I18n.t(mapping[route.path].adminTitleKey)
      : null;
    subtitle = mapping[route.path].adminSubtitleKey
      ? I18n.t(mapping[route.path].adminSubtitleKey)
      : null;
  } else {
    title = I18n.t(mapping[route.path].memberTitleKey);
    subtitle = I18n.t(mapping[route.path].memberSubtitleKey);
  }

  if (!title || !subtitle) {
    return null;
  }

  return <TipNotification key="panelTip" title={title} subtitle={subtitle} />;
};

Tip.propTypes = {
  route: PropTypes.object,
};

export default Tip;
